import styled from "@emotion/styled";

import MuiPhoneNumber from 'material-ui-phone-number'

export default styled(MuiPhoneNumber)`
  .MuiInputBase-root {
    background-color: #F0F0F0;
    padding-left: 8px;
    border-radius: 10px;
  }
  
  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  .MuiOutlinedInput-input {
    padding: 7px 8px 7px 0;
  }

  .MuiFormHelperText-root {
    margin-left: 0;
    margin-top: 9px;
  }
`;
